// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ahOb","col":"styles_col__373-H"};